__turbopack_context__.v({
  "card": "style-module-scss-module__z9HtXq__card",
  "cardFooter": "style-module-scss-module__z9HtXq__cardFooter",
  "cardTag": "style-module-scss-module__z9HtXq__cardTag",
  "cardText": "style-module-scss-module__z9HtXq__cardText",
  "container": "style-module-scss-module__z9HtXq__container",
  "heading": "style-module-scss-module__z9HtXq__heading",
  "image": "style-module-scss-module__z9HtXq__image",
  "navBtn": "style-module-scss-module__z9HtXq__navBtn",
  "next": "style-module-scss-module__z9HtXq__next",
  "partnershipSwiper": "style-module-scss-module__z9HtXq__partnershipSwiper",
  "prev": "style-module-scss-module__z9HtXq__prev",
  "section": "style-module-scss-module__z9HtXq__section",
  "sliderWrap": "style-module-scss-module__z9HtXq__sliderWrap",
  "subtitle": "style-module-scss-module__z9HtXq__subtitle",
  "swiper": "style-module-scss-module__z9HtXq__swiper",
  "title": "style-module-scss-module__z9HtXq__title",
});
